import React from 'react';

function LiveCallStatus({ steps, isActive }) {
  return (
    <div className="live-monitor">
      <div className="monitor-header d-flex align-items-center justify-content-between">
        <h6 className="mb-0 text-white">
          <i className="bi bi-broadcast me-2"></i>Live Call Monitor
        </h6>
        {isActive && (
          <span className="d-flex align-items-center gap-2">
            <span className="live-pulse"></span>
            <small className="text-success">LIVE</small>
          </span>
        )}
      </div>
      <div className="monitor-body">
        {steps.length === 0 ? (
          <p className="text-secondary fst-italic mb-0">
            <i className="bi bi-hourglass me-2"></i>
            Waiting for call activity...
          </p>
        ) : (
          steps.map((step, idx) => (
            <div key={idx} className="live-step d-flex align-items-start gap-3">
              <span className="text-secondary" style={{ fontFamily: "'Courier New', monospace", fontSize: '0.8rem', minWidth: 75 }}>
                {step.time}
              </span>
              <span className={getStepColor(step.type)}>
                {getStepIcon(step.type)}
                {step.message}
              </span>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

function getStepIcon(type) {
  const icons = {
    dialing: <i className="bi bi-telephone-outbound me-2"></i>,
    ringing: <i className="bi bi-bell me-2"></i>,
    answered: <i className="bi bi-telephone-inbound me-2"></i>,
    language_menu_played: <i className="bi bi-translate me-2"></i>,
    kyc_pending_played: <i className="bi bi-info-circle me-2"></i>,
    confirmation_played: <i className="bi bi-person-check me-2"></i>,
    validation_played: <i className="bi bi-shield-lock me-2"></i>,
    due_message_played: <i className="bi bi-exclamation-circle me-2"></i>,
    action_menu_played: <i className="bi bi-list-check me-2"></i>,
    dtmf: <i className="bi bi-hash me-2"></i>,
    verified: <i className="bi bi-shield-check me-2"></i>,
    action: <i className="bi bi-check2-square me-2"></i>,
    completed: <i className="bi bi-check-circle me-2"></i>,
    failed: <i className="bi bi-x-circle me-2"></i>,
  };
  return icons[type] || <i className="bi bi-dot me-2"></i>;
}

function getStepColor(type) {
  if (type === 'verified') return 'text-success';
  if (type === 'action') return 'text-danger';
  if (type === 'failed') return 'text-danger';
  if (type === 'completed') return 'text-info';
  if (type === 'dtmf') return 'text-warning';
  return 'text-light';
}

export default LiveCallStatus;
